import React, {forwardRef, useEffect, useState} from "react";
import {usePlyr} from "plyr-react";

/**
 * use the video player through a forward ref hook - see react-aptor for infos
 * 'forceautoplay' is required for autoplay on the first render because of browser restrictions
 * (for ex. for playing automatically a video on the landing page)
 */
//
export const PlyrVideoPlayer = forwardRef((props, ref) => {
    const {source, options = null, forceautoplay = false, muted = false,
        loop=false, autoplay= false,...rest} = props
    const [plyrOptions] = useState(() => {
            if(forceautoplay) return {
                storage: {enabled: false},
                autoplay: true,
                muted: true,
                loop: {active: loop},
                playsinline: true,
                controls: [], ...options};

            return {
                autoplay: autoplay,
                muted: muted,
                volume: muted ? 0 : 0.5,
                loop: {active: loop},
                controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'settings', 'pip', 'airplay', 'fullscreen'],
                ...options,
            }
        }
    )
    const validatedSource = source && source.sources ? source : { type: 'video', sources: [] };
    const raptorRef = usePlyr(ref, {
        source: validatedSource,
        options: plyrOptions,
    })

    useEffect(() => {
        const handleAutoPlay = async () => {
            if(forceautoplay && raptorRef.current && raptorRef.current.plyr) {
                const player = raptorRef.current.plyr;
                player.muted = true;
                player.volume = 0;
                try {
                    await player.play();
                } catch(e) {
                    console.log('Video autoplay failed', e)
                }
            }
        }
        const timer = setTimeout(() => {
            handleAutoPlay();
        }, 50)

        return () => clearTimeout(timer);

    }, [forceautoplay, raptorRef]);

    return <video ref={raptorRef} className="plyr-react plyr" {...rest} />
})
